import { Component, OnInit } from '@angular/core';
import { DocCodingResponsiveness } from "@enums/doc-coding-responsiveness.enum";
import { BaseComponent } from "../../../../base.component";
import { DocViewerStore } from "@store/legacy/doc-viewer.store";
import { switchMap, takeUntil } from "rxjs/operators";
import { merge, of } from "rxjs";

@Component({
    selector: 'lex-built-in-coding-section',
    templateUrl: './built-in-coding-section.component.html',
    styleUrls: ['./built-in-coding-section.component.scss'],
    standalone: false
})
export class BuiltInCodingSectionComponent extends BaseComponent implements OnInit {
	public readonly docCodingResponsiveness = DocCodingResponsiveness;

	constructor(public docViewerStore: DocViewerStore) {
		super();
	}

	ngOnInit(): void {
		this.docViewerStore.currentDocument$.pipe(
			switchMap(() => {
				return merge(
					of(null),
					this.docViewerStore.documentCodingFormGroup.get('privilege').valueChanges,
					this.docViewerStore.documentCodingFormGroup.get('workProduct').valueChanges
				)
			})
		).pipe(
			takeUntil(this.destroy$)
		).subscribe();
	}

	public disableRedactForPrivilege(): boolean {
		if (!this.docViewerStore.documentCodingFormGroup.get('privilege').value && !this.docViewerStore.documentCodingFormGroup.get('workProduct').value) {
			return !this.docViewerStore.documentCodingFormGroup.get('redactForPrivilege').value;
		}
		if (this.docViewerStore.documentCodingFormGroup.get('privilege').value || this.docViewerStore.documentCodingFormGroup.get('workProduct').value) {
			return false;
		}
	}
}
